import * as Yup from 'yup'
import { ITEM_REJECT_REASON } from 'domains/internal-request/constants'

const RejectItemSchema = (internalRequestItem) => Yup.object().shape({
  reject_reason : Yup.string().required('Required'),
  reject_note   : Yup.string().when('reject_reason', {
    is        : ITEM_REJECT_REASON.OTHER,
    then      : Yup.string().trim().required('Required'),
    otherwise : Yup.string().nullable()
  }),
  quantity      : Yup.number().moreThan(0)
    .max(internalRequestItem.quantity)
    .required('Required')
})

export default RejectItemSchema